import { useEffect, useState } from "react";
import { StandaloneCouponsAPI } from "../providers/StandaloneCouponsAPI";
import { Button } from "../shared/components/Button";
import { Title } from "../shared/components/Title";
import { If } from "../shared/components/control-statements";
import styles from "../styles/beneficios/detalhes-id.module.css";

import { Drawer } from "../shared/components/Drawer";
import { Icon } from "../shared/components/core/Icon";
import { BenefitInfo } from "../shared/containers/beneficios/BenefitInfo";
import { BenefitMetrics } from "../shared/containers/beneficios/BenefitMetrics";
import ChangeBenefitFolderDrawer from "../shared/containers/beneficios/folders/ChangeBenefitFolderDrawer";
import ContemplateCustomers from "../shared/containers/beneficios/steps/ContemplateCustomers";

const st = (className) => styles[className];

const steps = {
  OPTIONS: "OPTIONS",
  MOVE_BENEFIT: "MOVE_BENEFIT",
  CONTEMPLATE_CUSTOMERS: "CONTEMPLATE_CUSTOMERS",
};

export default function BenefitDetails() {
  const [benefit, setBenefit] = useState({});
  const [openOptions, setOpenOptions] = useState(false);
  const [step, setStep] = useState(steps.OPTIONS);

  const loadBenefit = async () => {
    const benefitId = window.location.href.split("/")[5];
    const loadedCoupon = await StandaloneCouponsAPI.getStandaloneCouponById(
      benefitId
    );
    setBenefit(loadedCoupon.getData({}));
  };

  const archiveBenefit = async () => {
    const confirmed = await window.confirm({
      text: "Você tem certeza que deseja arquivar este cupom? Esta ação não poderá ser desfeita.",
      confirmText: "Arquivar cupom",
      cancelText: "Cancelar",
    });

    if (!confirmed) {
      return false;
    }

    const response = await StandaloneCouponsAPI.putStandaloneCouponStatus(
      benefit.id,
      "ARCHIVED"
    );
    const errors = response.getErrors([]);
    if (errors.length > 0) {
      alert({ text: errors[0] });
    } else {
      setBenefit({ ...benefit, status: "ARCHIVED" });
      alert({ text: "Benefício arquivado com sucesso" });
    }
  };

  useEffect(() => {
    loadBenefit();
  }, []);

  return (
    <>
      <Title
        title="Detalhes de benefício"
        backTo={{ url: "/beneficios", name: "Benefícios" }}
      >
        <Button onClick={() => setOpenOptions(true)}>
          <Icon name="ellipsis-v" />
        </Button>
      </Title>
      <If cond={benefit.id}>
        <div className={st("wrapper")}>
          <BenefitInfo benefit={benefit} />
          <BenefitMetrics benefit={benefit} />
        </div>
      </If>

      <Drawer
        title="Opções"
        visible={openOptions}
        onClose={() => {
          setOpenOptions(false);
          setStep(steps.OPTIONS);
        }}
        showBackButton={step === steps.MOVE_BENEFIT}
        backButton={() => setStep(steps.OPTIONS)}
      >
        {step === steps.OPTIONS ? (
          <>
            <div className={styles.options}>
              <div
                className={styles.option}
                onClick={() => setStep(steps.MOVE_BENEFIT)}
              >
                <Icon name="turn-down-left" />
                <p>Mover benefício</p>
              </div>
              <div className={styles.option} onClick={archiveBenefit}>
                <Icon name="box-archive" />
                <p>Arquivar benefício</p>
              </div>
              {!benefit?.template && (
                <div
                  className={styles.option}
                  onClick={() => setStep(steps.CONTEMPLATE_CUSTOMERS)}
                >
                  <Icon name="gift" />
                  <p>Contemplar clientes</p>
                </div>
              )}
            </div>
          </>
        ) : null}
      </Drawer>

      <ChangeBenefitFolderDrawer
        visible={step === steps.MOVE_BENEFIT}
        backButton={() => setStep(steps.OPTIONS)}
        onClose={() => setStep(steps.OPTIONS)}
        withoutTransition
        benefit={benefit}
      />

      <Drawer
        visible={step === steps.CONTEMPLATE_CUSTOMERS}
        backButton={() => setStep(steps.OPTIONS)}
        showBackButton
        onClose={() => setStep(steps.OPTIONS)}
        title="Contemplar cliente"
        withoutTransition
        alreadyDrawer
      >
        <ContemplateCustomers
          couponId={benefit.id}
          onClose={() => setStep(steps.OPTIONS)}
          onFinishContemplation={() => loadBenefit()}
        />
      </Drawer>
    </>
  );
}
